/* eslint-disable react-hooks/exhaustive-deps */
import { Modal } from "react-bootstrap";
import { useEffect, useState, useMemo, Fragment, useCallback } from "react";
import queryString from "query-string";
import { useMutation, useQuery, useQueryClient } from "react-query";
import ReactPaginate from "react-paginate";
import { toast } from "react-toastify";
import "./../assets/scss/reports/cashbook.scss";
import useDebounce, { useQueryParams, useScrollTop } from "../utils/hooks";
import {
  paginationOptions,
  scrollToTop,
  sortOptions,
  VendorPayment,
  fetchActionsUtil,
} from "../utils/helpers";
import { useAuth } from "../hooks/useAuth";
import ConfirmDialog from "./ConfirmDialogue";
import PreviewFormOnlyComponent from "./Requisition/PreviewFormOnlyComponent";
import NoTableItem from "./utils/NoTableItem";
import PORequisitionModal from "./Requisition/PORequisition";
import { cloneDeep } from "lodash";
import { SelectedItemsTable } from "./RFQFunctions/SelectedItemsTable";
import { VendorListTable } from "./RFQFunctions/VendorListTable";
import { ItemTable } from "./RFQFunctions/ItemTable";
import { HeaderArea } from "./RFQFunctions/HeaderArea";

export default function RFQCompanyModal({
  show,
  onHide,
  selectedRFQ,
  disableInput,
  headerName,
  headerNo,
  theRFQName,
  requisition,
}) {
  const { backendUrl } = useAuth();
  const queryClient = useQueryClient();

  const initialFilterParams = { q: "", page: 1, limit: 40 };
  const normalizeQueryParams = (params) => ({
    ...params,
    onlyItems:
      params.onlyItems === true || params.onlyItems === "true" ? true : false,
  });
  const [queryParams, setQueryParams] = useQueryParams(initialFilterParams);
  const [filterParams, setFilterParams] = useState({
    ...initialFilterParams,
    ...normalizeQueryParams(queryParams),
  });
  const debouncedFilterParams = useDebounce(filterParams, 500);

  const [selectedFilledForm, setSelectedFilledForm] = useState(null);
  const [, setFetchingIframe] = useState(false);
  const [selectedID, setSelectedID] = useState("");
  const [tableData, setTableData] = useState([]);
  const [activeTableIndex, setActiveTableIndex] = useState(null);
  const [selectedData, setSelectedData] = useState([]);
  const [selectedAllData, setSelectedAllData] = useState([]);
  const [allOpenPos, setAllOpenPOs] = useState([]);
  const [ShowNewRequisitionModal, setShowNewRequisitionModal] = useState(false);
  const [vendorAttachments, setVendorAttachments] = useState([]);

  useScrollTop();

  useEffect(() => {
    setQueryParams((current) => ({ ...current, ...debouncedFilterParams }));
  }, [debouncedFilterParams, setQueryParams]);

  useEffect(() => {
    setFilterParams((current) => ({
      ...current,
      ...normalizeQueryParams(queryParams),
    }));
  }, [queryParams]);

  const fetchData = async ({ queryKey }) => {
    const [, RFQId, params] = queryKey;
    const data = await fetchActionsUtil(
      `${backendUrl}/api/vendors/particular-RFQ/${RFQId}?${queryString.stringify(
        params,
      )}`,
    );

    return {
      ...data,
      itemsData: [
        { label: "All Item", value: "" },
        ...(data.products || []).map((item) => ({
          label: item?.itemName,
          value: item?.itemName,
        })),
      ],
      vendorCert: [
        { label: "Select Vendor Cert", value: "" },
        ...(data?.vendorCert || []).map((cert) => ({
          label: cert,
          value: cert,
        })),
      ],
    };
  };

  const { data, refetch, isFetching } = useQuery(
    ["GET_PARTICULAR_RFQS", selectedRFQ?.RFQId, queryParams],
    fetchData,
    {
      enabled: Boolean(selectedRFQ?.RFQId),
      keepPreviousData: true,
    },
  );

  // useEffect(() => {
  //   if (isFetching) {
  //     setActiveTableIndex(null);
  //     setTableData([]);
  //     setSelectedID("");
  //   }
  // }, [isFetching]);

  // useEffect(() => {
  //   setSelectedData([]);
  //   setSelectedAllData([]);
  //   setActiveTableIndex(null);
  //   setTableData([]);
  //   setSelectedID("");
  //   setVendorAttachments([]);
  // }, [filterParams?.onlyItems]);

  const handleSearchQueryChange = (e) => {
    const { name, value } = e.target;
    setFilterParams((prev) => ({
      ...prev,
      page: 1,
      [name]: value,
    }));
  };

  const showRFQ = async (formId, childId) => {
    const { form } = await fetchActionsUtil(
      `${backendUrl}/api/forms/single-filled-form?FormID=${formId}&childFormId=${childId}`,
      "GET",
    );
    setSelectedFilledForm(form);
  };

  const showRFQTable = async (vendor, RFQId, requestid) => {
    const element = await fetchActionsUtil(
      `${backendUrl}/api/vendors/vendor-items?vendor=${vendor}&RFQId=${RFQId}&requestid=${requestid}`,
      "GET",
    );
    setTableData(element.data[0]?.items || []);
    setVendorAttachments(
      element?.quote?.quoteAttachments
        ? JSON.parse(element?.quote?.quoteAttachments)
        : [],
    );
  };

  const updateTableItem = ({ index, name, value }) => {
    setTableData((prev) => {
      const next = [...prev];
      next[index] = { ...next[index], [name]: value };
      return next;
    });
  };

  const AddPriceMutation = useMutation(
    (payload) =>
      fetchActionsUtil(
        `${backendUrl}/api/vendors/add-quote-price`,
        "post",
        "",
        payload,
      ),
    {
      onSuccess: ({ message }) => {
        toast.success(message);
        queryClient.invalidateQueries("GET_PARTICULAR_RFQS");
      },
      onError: ({ message = "" }) => {
        toast.error(`Unable to perform action: ${message}`);
      },
    },
  );

  const sendDataUpdate = async () => {
    const confirmed = await ConfirmDialog({
      title: "Save Price",
      description: "Are you sure you want to save the price",
    });

    if (confirmed) {
      AddPriceMutation.mutate({ tableData });
    }
  };

  const mergeUniqueItems = (current, items) => {
    const ids = new Set(current.map((item) => item.id));
    return [
      ...current,
      ...items.filter((item) => item.id != null && !ids.has(item.id)),
    ];
  };

  const toggleItem = (list, item) => {
    return list.some((it) => it.id === item.id)
      ? list.filter((it) => it.id !== item.id)
      : [...list, item];
  };

  const onSelected = useCallback(
    (item) => {
      setSelectedData((current) => {
        const exists = current.some((it) => it.id === item.id);
        const sameVendor = current.some((it) => it.vendor === item.vendor);

        if (exists) {
          return current.filter((it) => it.id !== item.id);
        }

        return sameVendor || current.length === 0 ? [...current, item] : [item];
      });
    },
    [setSelectedData],
  );

  const onSelectedOnly = useCallback(
    (item) => {
      setSelectedData((current) => toggleItem(current, item));
      setSelectedAllData((current) => toggleItem(current, item));
    },
    [setSelectedData, setSelectedAllData],
  );

  const selectAll = (e) => setSelectedData(e.target.checked ? tableData : []);

  const selectAllOnly = (e) =>
    setSelectedData(e.target.checked ? data?.vendorRFQ || [] : []);

  const getUniqueItems = (items = []) =>
    Array.from(new Map(items.map((i) => [i.id, i])).values());

  const itemDetails = useMemo(() => {
    const raw = data?.vendorRFQ || [];
    const unique = getUniqueItems(raw);

    const selectedIds = new Set(selectedData.map((i) => i.id));
    const base = unique.filter((i) => !selectedIds.has(i.id));

    return selectedAllData.length ? [...base, ...selectedAllData] : base;
  }, [data?.vendorRFQ, selectedData, selectedAllData]);

  // Fixed useEffect to avoid infinite loop by using raw data for source
  useEffect(() => {
    const source = filterParams?.onlyItems ? data?.vendorRFQ || [] : tableData;

    const selectedFromServer = source.filter((item) => item.selected);
    if (!selectedFromServer.length) return;

    setSelectedData((prev) => mergeUniqueItems(prev, selectedFromServer));

    if (filterParams?.onlyItems) {
      setSelectedAllData((prev) => mergeUniqueItems(prev, selectedFromServer));
    }
  }, [filterParams?.onlyItems, data?.vendorRFQ, tableData]);

  const openOnlyPO = () => {
    const vendors = [...new Set(selectedData.map((item) => item.vendor))];

    setAllOpenPOs(
      vendors.map((vendor) => ({
        open: true,
        items: selectedData
          .filter((item) => item.vendor === vendor)
          .map((item) => {
            const copy = cloneDeep(item);
            delete copy.VendorsRFQs;
            return copy;
          }),
      })),
    );
  };

  const SaveSelectedItem = useMutation(
    (payload) =>
      fetchActionsUtil(
        `${backendUrl}/api/vendors/save-rfq-selected`,
        "post",
        "",
        payload,
      ),
    {
      onSuccess: ({ message, closed }) => {
        queryClient.invalidateQueries("GET_COMPANY_RFQS");
        toast.success(message);
        closed && openOnlyPO();
      },
      onError: ({ message = "" }) => {
        toast.error(`Unable to perform action: ${message}`);
      },
    },
  );

  const saveSelectedItems = async () => {
    const confirmed = await ConfirmDialog({
      title: "Save Items",
      description: "Are you sure you want to save these items",
    });

    if (confirmed) {
      SaveSelectedItem.mutate({ selectedData });
    }
  };

  const approveAndClose = async () => {
    if (selectedRFQ?.closed) {
      return openOnlyPO();
    }

    const confirmed = await ConfirmDialog({
      title: "Approve And Close",
      description: "Are you sure you want to approve and close",
    });

    if (confirmed) {
      SaveSelectedItem.mutate({ selectedData, closed: true });
    }
  };

  const filteredItemDetails =
    itemDetails?.filter((item) => item.amount > 0) || [];
  const vendorRFQ = data?.vendorRFQ || [];

  const alreadyHasFinalApproval = requisition?.requisitiontracks?.find(
    (track) => track.closedHere,
  );

  const selectedDataLength = selectedData.length;

  return (
    <Modal
      show={show}
      onHide={() => onHide(false)}
      centered
      animation={false}
      enforceFocus={false}
      backdrop="static"
      fullscreen
    >
      <Modal.Header closeButton>
        <Modal.Title className="w-100">
          <div className="d-flex justify-content-between">
            <div>
              <h1 className="h5">{headerName}</h1>
            </div>
            <div>
              <h1 className="h6 mx-4">{headerNo}</h1>
            </div>
          </div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <main className="inner-page-outlet">
          <main className="cash-book">
            <div className="content">
              <HeaderArea
                filterParams={filterParams}
                setFilterParams={setFilterParams}
                refetch={refetch}
                data={data}
                VendorPayment={VendorPayment}
                sortOptions={sortOptions}
              />

              {filterParams?.onlyItems ? (
                <SelectedItemsTable
                  filteredItemDetails={filteredItemDetails}
                  selectedData={selectedData}
                  onSelectedOnly={onSelectedOnly}
                  selectAllOnly={selectAllOnly}
                  vendorRFQ={vendorRFQ}
                  isSelected={selectedRFQ?.closed}
                />
              ) : (
                <div className="row">
                  <div className="col-4">
                    <VendorListTable
                      vendorRFQ={vendorRFQ}
                      isFetching={isFetching}
                      activeTableIndex={activeTableIndex}
                      selectedID={selectedID}
                      setSelectedID={setSelectedID}
                      setActiveTableIndex={setActiveTableIndex}
                      showRFQ={showRFQ}
                      setVendorAttachments={setVendorAttachments}
                      showRFQTable={showRFQTable}
                      setSelectedFilledForm={setSelectedFilledForm}
                    />

                    {!vendorRFQ.length && !isFetching && (
                      <div className="d-flex justify-content-center text-center w-100 my-4">
                        <NoTableItem queryParams={queryParams} />
                      </div>
                    )}
                  </div>

                  <div className="col-8">
                    {selectedID ? (
                      selectedFilledForm ? (
                        <PreviewFormOnlyComponent
                          selectedFilledForm={selectedFilledForm}
                          template={selectedFilledForm?.filledFormData}
                          setFetchingIframe={setFetchingIframe}
                          size="30rem"
                          canFill={false}
                          showTableCheckbox={false}
                          printForm
                        />
                      ) : (
                        <ItemTable
                          tableData={tableData}
                          selectedData={selectedData}
                          onSelected={onSelected}
                          selectAll={selectAll}
                          updateTableItem={updateTableItem}
                          disableInput={disableInput}
                          vendorAttachments={vendorAttachments}
                          backendUrl={backendUrl}
                          isSelected={selectedRFQ?.closed}
                        />
                      )
                    ) : (
                      <div className="d-flex justify-content-center text-center w-100 my-4">
                        <NoTableItem queryParams="No quote selected" />
                      </div>
                    )}

                    {!disableInput && selectedID && (
                      <div className="d-flex justify-content-end">
                        <button
                          onClick={sendDataUpdate}
                          className="btn btn-primary"
                          disabled={AddPriceMutation.isLoading}
                        >
                          {AddPriceMutation.isLoading
                            ? "Saving..."
                            : "Create Quote"}
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              )}

              {selectedDataLength > 0 && (
                <div className="d-flex justify-content-center my-3">
                  <button
                    className="btn btn-primary mx-4"
                    onClick={saveSelectedItems}
                    disabled={selectedRFQ?.closed}
                  >
                    Save Selected
                  </button>
                  {alreadyHasFinalApproval && (
                    <button
                      onClick={approveAndClose}
                      className="btn btn-primary"
                    >
                      {selectedRFQ?.closed ? "Create PO" : "Approve and Close"}
                    </button>
                  )}
                </div>
              )}

              <div className="d-flex justify-content-between px-3 align-items-center pagination">
                <div className="pagination_left">
                  <p className="m-0 p-0">Show</p>
                  <select
                    value={queryParams.limit}
                    name="limit"
                    className="form-select"
                    onChange={handleSearchQueryChange}
                  >
                    <option value="10">10 rows</option>
                    <option value="20">20 rows</option>
                    <option value="30">30 rows</option>
                    <option value="40">40 rows</option>
                    <option value="50">50 rows</option>
                    <option value="100">100 rows</option>
                  </select>
                </div>

                <ReactPaginate
                  {...paginationOptions}
                  pageCount={Math.ceil((data?.count || 0) / queryParams.limit)}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={0}
                  onPageChange={({ selected }) => {
                    setQueryParams((prev) => ({
                      ...prev,
                      page: selected + 1,
                    }));
                    scrollToTop();
                  }}
                  forcePage={queryParams.page - 1}
                />
              </div>
            </div>
          </main>
        </main>

        {ShowNewRequisitionModal && (
          <PORequisitionModal
            setShowNewRequisitionModal={setShowNewRequisitionModal}
            ShowNewRequisitionModal={ShowNewRequisitionModal}
            selectedItems={selectedData}
          />
        )}

        {allOpenPos.map((item, index) => (
          <Fragment key={index}>
            <PORequisitionModal
              setShowNewRequisitionModal={(isOpen) =>
                setAllOpenPOs((old) =>
                  old.map((o, i) => ({
                    ...o,
                    open: i === index ? isOpen : o.open,
                  })),
                )
              }
              ShowNewRequisitionModal={item.open}
              selectedItems={item.items}
              disableVendor
              theRFQName={`${theRFQName} PO`}
            />
          </Fragment>
        ))}
      </Modal.Body>
    </Modal>
  );
}
